export default "__VITE_ASSET__CqTiof1s__"